module.exports = __webpack_public_path__ + "static/media/FuturaStd-Medium.3eb70175.svg";